// DEPENDENCIES
import React, { useState } from 'react';
import PropTypes from 'prop-types';

const FormBlock = (props) => {
    return (
        <>
            <form 
                className={`form-block-container ${props.className ? props.className : ""}`}
                onSubmit={props.onSubmit}
                style={props.style}
            >
                {props.children}
            </form>
        </>
    )
}

FormBlock.propTypes = {
    // MAIN PROPS
    className: PropTypes.string,

    // FORM ACTION PROPS
    onSubmit: PropTypes.func,
}

export default FormBlock;